import COMPARE_LIMITS from 'consts/compareLimits'

function getCompareLimits(isWinner = false) {
  return isWinner ? COMPARE_LIMITS.winner : COMPARE_LIMITS.regular
}

export default getCompareLimits
